import Vue from "vue"
import store from '@/store/index.js'

has_access_right = (access_name)->
    # console.log "HAS ACCESS RIGHT ", access_name
    all_rights = '*' in store.state.user_datas.accesses
    specific_right = access_name in store.state.user_datas.accesses
    return all_rights or specific_right

manage_people = ()->
    return '*' in store.state.user_datas.accesses or 'manage_all' in store.state.user_datas.accesses \
        or 'manage_subordinates' in store.state.user_datas.accesses or 'manage_all_but_superiors' in store.state.user_datas.accesses

deep_copy = (obj)->
    return JSON.parse(JSON.stringify(obj))

phone_format = (str)->
    tmp_str = str
    if str.length >= 3 and str.length % 3 == 0 and str.substring(str.length-1) != ' '
        tmp_str = str.substring(0, str.length-1) + ' ' + str.substring(str.length-1)
    return tmp_str

date_formatter = (date)->
    # console.log "DATE FORMATTER ", date
    new_date = ""
    if date?
        date_array = date.split('-')
        new_date = date_array[2]+'/'+date_array[1]+'/'+date_array[0]
    return new_date

datetime_formatter = (datetime)->
    # console.log "DATETIME FORMATTER ", datetime
    new_date = ""
    if datetime?
        datetime_array = datetime.split('T')
        if datetime_array.length == 1
            datetime_array = datetime.split(' ')
        date_array = datetime_array[0].split('-')
        time_array = datetime_array[1].split(':')
        new_date = date_array[2]+'/'+date_array[1]+'/'+date_array[0]+" à "+time_array[0]+"h"+time_array[1]
    return new_date

time_formatter = (datetime)->
    # console.log "TIME FORMATTER ", datetime
    time = ""
    if datetime?
        datetime_array = datetime.split('T')
        if datetime_array.length == 1
            datetime_array = datetime.split(' ')
        time_array = datetime_array[1].split(':')
        time = time_array[0]+"h"+time_array[1]
    return time

add_zero = (number)->
    return '0'+number

python_date_formatter = (datetime)->
    # console.log "PYTHON DATE FORMATTER ", datetime
    new_date = ''
    if datetime?
        year = datetime.getFullYear()
        month = datetime.getMonth()+1
        if month < 10
            month = add_zero(month)
        date = datetime.getDate()
        if date < 10
            date = add_zero(date)
        hours = datetime.getHours()
        if hours < 10
            hours = add_zero(hours)
        minutes = datetime.getMinutes()
        if minutes < 10
            minutes = add_zero(minutes)
        seconds = datetime.getSeconds()
        if seconds < 10
            seconds = add_zero(seconds)
        new_date = year+'-'+month+'-'+date+' '+hours+':'+minutes+':'+seconds
    return new_date

absences_title = (accesses_array)->
    title = ""
    title_array = []
    if has_access_right(accesses_array[0])
        # title_array.push('Congés')
        title_array.push('Absences')
    if has_access_right(accesses_array[1])
        # title_array.push('Absences')
        title_array.push('Télétravail')
    # if has_access_right(accesses_array[2])
    #     title_array.push('Astreintes')
    if title_array.length == 1
        title += title_array[0]
    if title_array.length == 2
        title += title_array[0]
        title += ' et '
        title += title_array[1]
    if title_array.length == 3
        title += title_array[0]
        title += ', '
        title += title_array[1]
        title += ' et '
        title += title_array[2]
    return title

download_file = (url, filename)->
    Vue.http({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
    })
    .then (resp)->
        url = window.URL.createObjectURL(new Blob([resp.data]))
        link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        link.click()
    .catch (error)->
        console.log 'download error'

export default {
    manage_people: manage_people
    time_formatter: time_formatter
    python_date_formatter: python_date_formatter
    has_access_right: has_access_right
    deep_copy: deep_copy
    datetime_formatter: datetime_formatter
    date_formatter: date_formatter
    absences_title: absences_title
    download_file: download_file
    phone_format: phone_format
}

